import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { contactAttributeSliceAction } from '../../store/contactAttributeSlice';
import { RiSave3Fill } from "react-icons/ri";
import { MdClose } from "react-icons/md";
import { agentSliceAction } from "../../store/agentSlice";

import { addInCall, chatSliceAction } from '../../store/chatSlice';
import styled from 'styled-components';
import { BiTransfer } from 'react-icons/bi';
import { FiExternalLink } from 'react-icons/fi';
import {savetolocal,Updatelocal,deletelocal} from "../../utils/utils"

import interactionCategories from '../../config/schneider/interactionCategories.json';
import shortDescriptions from '../../config/schneider/shortDescriptions.json';
import Select from 'react-select';

const QuickConnectsContainer = styled.div`
    background: white;
    margin: 1rem 1.25rem 0rem 1.25rem;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const QuickConnectItem = styled("div") <{ index: number, isSelected: boolean }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    border-radius: 5px;
    background: ${(props) => ((props.isSelected ? "#ebebeb" : (props.index % 2 === 0) ? "white" : "#f5f5f5"))};
    cursor: pointer;
    span {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.8);
    margin: 5px;
    }
    :hover {
    background: #ebebeb;
    }
`;

const ChatInfo = () => {
    const dispatch = useDispatch();
    const timerRef = useRef<any>(null);
    const contactAttributes = useSelector((state: any) => { return state.contactAttributeSlice?.contactAttributes });
    const chatSliceData = useSelector((state: any) => { return state.chatSlice });

    const [alertDisplay, setAlertDisplay] = useState(false);
    const [ticketNumberexisted, setTicketNumberexisted] = useState(false);
    const [ticketNumber, setTicketNumber] = useState("");
    const [ticketNumberbypass, setTicketNumberBypass] = useState(false);
    const [ticketValidated, setTicketValidated] = useState(false);
    const [Interaction, setSelectedInteraction] = useState("");
    const [Resolution, setSelectedResolution] = useState("");
    const [WorkNotes, setWorkNotes] = useState("");
    const [ShortDescription, setSelectedShortDescription] = useState("");
    const [isOtherSelected, setIsOtherSelected] = useState(false);
    
    const [ticketErrorMessage, setTicketErrorMessage] = useState(<></>);
    const [validTicketMessage, setValidTicketMessage] = useState("");
    const [quickConnectinfo, setQuickConnectInfo] = useState(false);
    const [quickContactList, setQuickContactList] = useState([]);
    const [selectedTransfer, setSelectedTransfer] = useState("");
    const [search, setSearch] = useState("");
    const [matches, setMatches] = useState<any[]>([]);
    const agentObj = useSelector((state: any) => { return state.agentSlice.agentObj });

    const [searchDescriptionTerm, setSearchDescriptionTerm] = useState("");

    const handleSearchDescription = (event: any) => {
        setSearchDescriptionTerm(event.target.value);
    };

    const filteredDescriptions = shortDescriptions
        .filter(description =>
            description.toLowerCase().includes(searchDescriptionTerm.toLowerCase())
        )
        .map(description => ({
            value: description,
            label: description
    }));

    var index = 0;


    useEffect(() => {
        return () => clearTimeout(timerRef.current);
    }, []);






    useEffect(() => {
        setTicketNumber("");
        setTicketNumberBypass(false);
        setTicketErrorMessage(<></>);
        setTicketValidated(false);
        setSelectedInteraction("");
        setSelectedResolution("");
        setWorkNotes("");
        
        savetolocal("ShortDescriptions", chatSliceData?.selectedInfo?.short_description?.value || "", chatSliceData.selectedChat);
        savetolocal("TicketNumber", chatSliceData?.selectedInfo?.ticket_number?.value || "", chatSliceData.selectedChat);
        savetolocal("Interaction", chatSliceData?.selectedInfo?.interaction?.value || "", chatSliceData.selectedChat);
        savetolocal("Resolution", chatSliceData?.selectedInfo?.resolution?.value || "", chatSliceData.selectedChat);
        savetolocal("WorkNotes", chatSliceData?.selectedInfo?.work_notes?.value || "", chatSliceData.selectedChat);
        
        let CurrentShortDescriptionStorage = JSON.parse(localStorage.getItem("ShortDescriptions") || "{}");
        let CurrentTicketNumberStorage = JSON.parse(localStorage.getItem("TicketNumber") || "{}");
        let CurrentInteractionStorage = JSON.parse(localStorage.getItem("Interaction") || "{}");
        let CurrentResolutionStorage = JSON.parse(localStorage.getItem("Resolution") || "{}");
        let CurrentWorkNotesStorage = JSON.parse(localStorage.getItem("WorkNotes") || "{}");
        
        setSelectedShortDescription(CurrentShortDescriptionStorage[chatSliceData.selectedChat] || "");
        setTicketNumber(CurrentTicketNumberStorage[chatSliceData.selectedChat] || "");
        setSelectedInteraction(CurrentInteractionStorage[chatSliceData.selectedChat] || "");
        setSelectedResolution(CurrentResolutionStorage[chatSliceData.selectedChat] || "");
        setWorkNotes(CurrentWorkNotesStorage[chatSliceData.selectedChat] || "");
        
        setIsOtherSelected(false);
    }, [chatSliceData.selectedChat]);
    
    const getSNowUrl = () => {
        var url = "";
        Object.keys(chatSliceData.selectedInfo).map((key) => {
            if (key === "ServiceNowLookup") {
                url = chatSliceData.selectedInfo[key]["value"];
            }
        })
        return url;
    }
    
    const isAccountName = (accountName: string) => {
        var name = chatSliceData?.selectedInfo?.AccountName?.value;
        return name.toLowerCase() === accountName.toLowerCase();
    }
    
    const getQuickContactList = async () => {
        agentObj.getEndpoints(agentObj.getAllQueueARNs(), {
            success: function (data: any) {
                setQuickContactList(data.endpoints);
            },
            failure: function () { }
        });
    }
    
    const onChangeTicketNumber = (event: any) => {
        setTicketNumber(event.target.value);
        Updatelocal("TicketNumber", event.target.value, chatSliceData.selectedChat);
    }
    
    const onChangeShortDescription = (event: any) => {
        const shortDescriptionValue = event.target.value;
        setSelectedShortDescription(shortDescriptionValue);
        Updatelocal("ShortDescriptions", shortDescriptionValue, chatSliceData.selectedChat);
    };
    
    
    const onChangeInteraction = (event: any) => {
        const interactionValue = event.target.value;
        setSelectedInteraction(interactionValue);
        Updatelocal("Interaction", interactionValue, chatSliceData.selectedChat);
    };
    
    const onChangeResolution = (event: any) => {
        const resolutionValue = event.target.value;
        setSelectedResolution(resolutionValue);
        Updatelocal("Resolution", resolutionValue, chatSliceData.selectedChat);
    };
    
    
    
    const onChangeWorkNotes = (event: any) => {
        const WorkNotesvalue = event.target.value;
        setWorkNotes(WorkNotesvalue);
        Updatelocal("WorkNotes", WorkNotesvalue, chatSliceData.selectedChat);
    }

    const [apiResponse, setApiResponse] = useState<ApiResponse | null>(null);
    const [endingChat, setEndingChat] = useState(false);

    interface ApiResponse<T = Record<string, any>> {
        invalid_ticket?: boolean;
        success?: boolean;
        new_attrs?: T;
    }

    useEffect(() => {
        if(apiResponse) {
            var fields = ["Resolution", "Interaction", "WorkNotes","ShortDescription"]
            var new_fields = Object.keys(apiResponse.new_attrs||{})

            const map: Record<string, string> = {
                TicketNumber: "Ticket Number",
                Resolution: "Resolution Type",
                Interaction: "Interaction Category",
                WorkNotes: "Work Notes",
                ShortDescription: "Short Description"
            };

            const readable_fields = new_fields.map(field => map[field] || field);

            if (new_fields.length !== 0) {
                if (ticketValidated && ticketNumberexisted){
                    const x = readable_fields.filter(item => item !== "Ticket Number");
                    setValidTicketMessage("The following data has still been saved: " + x.join(', '))
                    setTicketNumberexisted(false)
                }
                if (new_fields.includes("TicketNumber")) {
                    const x = readable_fields.filter(item => item !== "Ticket Number");
                    if (!ticketValidated) {
                        setTicketErrorMessage(
                            <>
                                <span style={{ color: 'red' }}>
                                    Ticket number is not valid.
                                </span>
                                {x.length === 0 ? null : (
                                <>
                                <span style={{ color: '#155724' }}>
                                    {' '}The following data has still been saved: {x.join(', ')}
                                </span>
                                </>
                                )}
                            </>
                        );
                    } else if (ticketNumber == "") {
                        setTicketErrorMessage(
                            <>
                                <span style={{ color: 'red' }}>No ticket number was specified.</span> 
                                <span style={{ color: '#155724'}}>The following data has been saved: {x.join(', ')}</span>
                            </>)
                    } else {
                        let responseTicket = apiResponse?.new_attrs?.TicketNumber;
                        let updatedAttributes = contactAttributes.map((item: any) => {
                            var temp = Object.assign({}, item);
                            if (item.contactId === chatSliceData.selectedChat) {
                                if (temp.contactAttributes.hasOwnProperty("TicketNumber")) {
                                    temp.contactAttributes = Object.assign({}, item.contactAttributes, { 'TicketNumber': { 'value': responseTicket } });
                                } else {
                                    temp.contactAttributes = { 'TicketNumber': { 'value': responseTicket } };
                                }
                            }
                            return temp;
                        });
                        setValidTicketMessage("Ticket validated, the following data has been saved: " + readable_fields)
                        dispatch(contactAttributeSliceAction.updateContactAttributes(updatedAttributes));
                    }
                } else {
                    const missingData = fields.filter(s => !new_fields.includes(s));
                    console.log("missed: " + missingData)
                    setTicketErrorMessage(
                        <>
                            <span style={{ color: '#155724' }}>
                                The following data has been successfully saved:{' '}
                                {readable_fields.filter(item => item !== "Ticket Number").join(', ')}
                            </span>
                        </>
                    );
                }
            } else {
                setTicketErrorMessage(
                    <>
                        You haven't submitted any data. Please fill in the fields you'd like to save.
                    </>
                );
            }
            setAlertDisplay(true);
            // Reset text fields
            if (!endingChat) {
                setTicketNumberexisted(true)
                setTicketNumber("");
            }
            timerRef.current = setTimeout(() => setAlertDisplay(false), 5000);
        }
    }, [ticketValidated, apiResponse, endingChat]);

    const onSaveWrapupCode = (endingChat: boolean) => {
        if (ticketNumber === "" && !ticketNumberbypass && !isAccountName("schneider")) {
            setTicketErrorMessage(<>Enter ticket number</>);
            return false;
        }

        let finalTicketNumber = ticketNumber;
        if (process.env.REACT_APP_AWS_CCP_REGION === "eu-west-2" && /^\d*$/.test(ticketNumber)) {
            finalTicketNumber = "INC-" + ticketNumber;
        }


        var elements = document.getElementsByClassName('text-input-notes');
        for (var i = 0; i < elements.length; i++) {
            var element = elements[i] as HTMLElement;
            element.style.height = '50px';
        }
        

        let requestData: any = {
            contact_id: chatSliceData.selectedChat,//"f7210797-e1ec-4ac4-9474-5537e7542d14",//chatSliceData.selectedChat,
            ticket_number: finalTicketNumber,
            account_name: chatSliceData.selectedInfo.AccountName.value,
            Resolution: Resolution,
            Interaction: Interaction,
            WorkNotes: WorkNotes,
            ShortDescription: ShortDescription
        }

        return fetch(process.env.REACT_APP_API_GETWAY_URL + "set-wrap-code", {
            method: "POST",
            body: JSON.stringify(requestData),
        }).then(resp => {
            if (!resp.ok) throw new Error("Non 200 response: " + resp.status);
            return resp.json();
        }).then(resp => {
            console.log(resp);
            setEndingChat(endingChat);
            setTicketValidated(!resp.invalid_ticket);
            setApiResponse(resp);
            return;
        });
    }

    useEffect(() => {
        const onChangeSearch = setTimeout((event: any) => {
            searchMatches(search);
        }, 1000)
        return () => clearTimeout(onChangeSearch)
    }, [search])

    const searchMatches = (input: string) => {
        let results: any[] = [];
        quickContactList.forEach((quickConnect: any) => {
            if ((quickConnect["name"].toLowerCase()).includes(input.toLowerCase())) {
                results.push(quickConnect);
            }
        })
        setMatches(results);
    }

    return (
        <div className="card call-info collapse show mt-3" id="chat_info">
            <div className="card-body">
                <div className="d-flex justify-content-between align-items-center">
                    <h6 className='m-0'>Controls</h6>
                </div>
                {(chatSliceData.selectedChat !== "") ? (
                    <ul className='calling-data list-unstyled' style={{ overflow: "hidden" }}>
                        {chatSliceData.selectedType === "monitoring" ? (
                            <></>
                        ) : (
                            <li style={{ width: "25%" }}>
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                    <form>
                                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                            <div className="form-group mb-3">
                                                {alertDisplay ? (
                                                    ticketValidated ? (
                                                        // The ticket is valid.
                                                        <label className='mb-2' style={{ color: "#155724", fontWeight: "bold" }}>{validTicketMessage}</label>
                                                    ) : (
                                                        // The ticket is invalid, therefore we display the error message.
                                                        <label className='mb-2' style={{ fontWeight: "bold" }}>{ticketErrorMessage}</label>
                                                    )
                                                ) : (
                                                    // The ticket number field is empty.
                                                    <label className='mb-2'>Ticket Number</label>
                                                )
                                                }
                                                <input onChange={(event) => { onChangeTicketNumber(event) }} value={ticketNumber} type="text" className={`form-control ${(!ticketValidated && !ticketErrorMessage) ? "is-invalid" : ""}`} placeholder='Enter ticket number' />
                                                <label htmlFor="Short Description" className='mb-2'>Short Description</label>
                                                {agentObj.getRoutingProfile().name.includes("Schneider") ? (
                                                    <div>
                                                        <div>
                                                        <Select
                                                        value={typeof ShortDescription === "string"
                                                            ? filteredDescriptions.find(option => option.value === ShortDescription) || null
                                                            : ShortDescription
                                                        }
                                                        options={filteredDescriptions}
                                                        onChange={(selectedOption) => {
                                                            const selectedValue = selectedOption ? selectedOption.value : "";
                                                            setSelectedShortDescription(selectedValue);
                                                            setIsOtherSelected(selectedValue === "Other");
                                                            Updatelocal("ShortDescriptions", selectedValue, chatSliceData.selectedChat); // Guarda el valor en localStorage
                                                        }}
                                                        placeholder="Search..."
                                                    />

                                                    {isOtherSelected && (
                                                        <input 
                                                            type="text" 
                                                            className="form-control" 
                                                            value={(ShortDescription === "Other" ? "" : ShortDescription) as string} 
                                                            onChange={onChangeShortDescription} 
                                                            placeholder="Enter a short description"
                                                        />
                                                    )}
                                                    </div>
                                                        <label htmlFor="Interaction Category" className='mb-2'>Interaction Category</label>
                                                        <div>
                                                            <button className="btn btn-sm dropdown-toggle btn-outline-orange" data-bs-toggle="dropdown">
                                                                <ul id="Interaction Category" className="dropdown-menu">
                                                                    {interactionCategories.map((category, index) => (
                                                                        <li key={index}>
                                                                            <button onClick={(event) => onChangeInteraction({ target: { value: category }})} className="dropdown-item">{category}</button>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                                {Interaction}
                                                            </button>
                                                        </div>
                                                        {/* TODO: Move resolutions type a config JSON */}
                                                        <label htmlFor="Resolution Type" className='mb-2'>Resolution Type</label>
                                                        <div>
                                                        <button className="btn btn-sm dropdown-toggle btn-outline-orange" data-bs-toggle="dropdown">
                                                            <ul id="Resolution Type" className="dropdown-menu">
                                                                <li key="resolved">
                                                                    <button onClick={(event) => onChangeResolution({ target: { value: "resolved" }})} className="dropdown-item">
                                                                        Resolved
                                                                    </button>
                                                                </li>
                                                                <li key="information provided on raising service request">
                                                                    <button onClick={(event) => onChangeResolution({ target: { value: "information provided on raising service request" }})} className="dropdown-item">
                                                                        Information provided on <br /> raising service request
                                                                    </button>
                                                                </li>
                                                                <li key="information provided by sharing kb article">
                                                                    <button onClick={(event) => onChangeResolution({ target: { value: "information provided by sharing kb article" }})} className="dropdown-item">
                                                                        Information provided by<br />sharing KB Article
                                                                    </button>
                                                                </li>
                                                                <li key="not resolved--follow-up actions needed">
                                                                    <button onClick={(event) => onChangeResolution({ target: { value: "not resolved--follow-up actions needed" }})} className="dropdown-item">
                                                                        Not Resolved / Follow Up<br /> actions needed
                                                                    </button>
                                                                </li>
                                                                <li key="service request created-- follow-up actions needed">
                                                                    <button onClick={(event) => onChangeResolution({ target: { value: "service request created-- follow-up actions needed" }})} className="dropdown-item">
                                                                        Service Request Created / Follow Up<br /> actions needed
                                                                    </button>
                                                                </li>
                                                                <li key="ticket status update">
                                                                    <button onClick={(event) => onChangeResolution({ target: { value: "ticket status update" }})} className="dropdown-item">
                                                                        Ticket Status Update
                                                                    </button>
                                                                </li>
                                                                <li key="dropped chat">
                                                                    <button onClick={(event) => onChangeResolution({ target: { value: "dropped chat" }})} className="dropdown-item">
                                                                        Dropped Chat
                                                                    </button>
                                                                </li>
                                                            </ul>
                                                            {Resolution.substring(0, 25)}
                                                        </button>
                                                    </div>
                                                        <label htmlFor="Work Notes" className='mb-2'>Work Notes</label>
                                                        <textarea id="text-input" className='text-input-notes' autoFocus rows={3} onChange={(event) => { onChangeWorkNotes(event) }} value={WorkNotes} placeholder="Add your notes for this chat here" style={{ width: "100%", fontSize: "15px", outline: "none", border: "none" }} />
                                                    </div>
                                                ) : <textarea id="Short Description" onChange={(event) => { onChangeShortDescription(event) }} value={ShortDescription}  className={"form-control"}/>}
                                            </div>
                                            <div style={{ display: "flex", flexDirection: "row" }}>
                                                <button onClick={() => {
                                                    if (isAccountName("Schneider")) {
                                                        setTicketNumberBypass(true);
                                                    }
                                                    onSaveWrapupCode(false);
                                                }} type="button" className="form-control btn btn-primary mt-3" style={{ height: "50%", marginLeft: "1rem", marginBottom: "0.3rem" }}><RiSave3Fill /> Save</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </li>
                        )}
                        {getSNowUrl() !== "" ? (
                            <li style={{ width: "25%" }}>
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: "0.6rem" }}>
                                    <button type="button" className="form-control btn btn-primary mt-3" onClick={() => { window.open(getSNowUrl(), "_blank") }} style={{ height: "50%", width: "75%" }}>
                                        {"To ITSM Tool "}
                                        <FiExternalLink size={18} color={"white"} style={{ marginBottom: "0.2rem" }} />
                                    </button>
                                </div>
                            </li>
                        ) : (
                            <></>
                        )}
                        {chatSliceData.selectedType === "monitoring" ? (
                            <></>
                        ) : (
                            <li style={{ width: "25%" }}>
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: "0.6rem" }}>
                                    <button type="button" className="form-control btn btn-primary mt-3" onClick={() => { getQuickContactList(); setQuickConnectInfo(!quickConnectinfo); }} style={{ height: "50%", width: "75%" }}>
                                        <i className="fas fa-fw fas fa-address-book"></i>
                                        {" Quick connects"}
                                    </button>
                                </div>
                            </li>
                        )}
                        {(quickConnectinfo && !chatSliceData.isSelectedChatEnded) ? (
                            <div style={{ display: "flex", flexDirection: "column", position: "absolute", right: "25.7%", width: "24.3%", height: "13.5rem", backgroundColor: "white", borderRadius: "5px", boxShadow: "0 5px 6px rgb(20 27 43 / 10%)", marginTop: "5rem", zIndex: "100" }}>
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                    <input maxLength={100} onChange={(event) => { setSearch(event.target.value) }} value={search} type="text" placeholder='Search for a Quick Connect' className='searchBar' style={{ borderWidth: "1px", margin: "1rem 0rem 0.25rem 0rem" }} />
                                </div>
                                <QuickConnectsContainer>
                                    {search === "" ? (
                                        quickContactList.map(({ endpointId, name },) => {
                                            index++;
                                            return (
                                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}>
                                                    <QuickConnectItem index={index} isSelected={endpointId === selectedTransfer} onClick={() => { setSelectedTransfer(endpointId); }}>
                                                        <span>{name}</span>
                                                    </QuickConnectItem>
                                                </div>
                                            )
                                        })
                                    ) : (
                                        matches.map(({ endpointId, name },) => {
                                            index++;
                                            return (
                                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}>
                                                    <QuickConnectItem index={index} isSelected={endpointId === selectedTransfer} onClick={() => { setSelectedTransfer(endpointId); }}>
                                                        <span>{name}</span>
                                                    </QuickConnectItem>
                                                </div>
                                            )
                                        })
                                    )}
                                </QuickConnectsContainer>
                                <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", marginBottom: "0.5rem" }}>
                                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                        <button onClick={() => { setSelectedTransfer(""); setQuickConnectInfo(false); }} type="button" className="form-control btn btn-danger mt-3" style={{ marginRight: "1rem", display: "flex", flexDirection: "row", alignItems: "center" }}>
                                            <MdClose size={18} color={"white"} />
                                            <span style={{ fontSize: "13px", whiteSpace: "pre" }}>{" Close"}</span>
                                        </button>
                                        <button onClick={async () => {
                                            let Transfered = await addInCall(chatSliceData.chats, selectedTransfer, quickContactList, chatSliceData.selectedChat);
                                            console.log(Transfered)
                                            if (Transfered) {
                                                dispatch(chatSliceAction.closeContact({ chatId: chatSliceData.selectedChat }));
                                            }
                                            setSelectedTransfer("");
                                            setQuickConnectInfo(false);
                                        }} type="button" className="form-control btn btn-primary mt-3" style={{ marginLeft: "1rem", display: "flex", flexDirection: "row", alignItems: "center" }}>
                                            <BiTransfer size={18} color={"white"} />
                                            <span style={{ fontSize: "13px", whiteSpace: "pre" }}>{" Transfer"}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <></>
                        )}
                        {chatSliceData.isSelectedChatEnded ? (
                            <li style={{ width: "25%" }}>
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: "0.6rem" }}>
                                    <button onClick={() => {
                                        if (isAccountName("Schneider")) {
                                            if (isOtherSelected && (ShortDescription === "Other" || ShortDescription === "")) {
                                                setTicketErrorMessage(
                                                    <>
                                                    <span style={{ color: 'red' }}>
                                                        Please type a valid short description before closing this chat.                                             
                                                    </span>
                                                    </>
                                                );
                                                setAlertDisplay(true);
                                                timerRef.current = setTimeout(() => setAlertDisplay(false), 5000);
                                                return;
                                            }
                                            if (Resolution !== "" && Interaction !== "") {
                                                setTicketNumberBypass(true);
                                                deletelocal("ShortDescriptions",chatSliceData.selectedChat);
                                                dispatch(chatSliceAction.closeContact({ chatId: chatSliceData.selectedChat }));
                                            } else {
                                                deletelocal("ShortDescriptions",chatSliceData.selectedChat);
                                                dispatch(agentSliceAction.setIsMissingWrapCode({ MissingWrapCode: true }));
                                            } 
                                        } else {
                                            if (isAccountName("Legrand") && ticketNumber ==="") {
                                                setTicketErrorMessage(
                                                    <>
                                                    <span style={{ color: 'red' }}>
                                                        Please fill the ticket number and try again.                                              
                                                    </span>
                                                    </>
                                                );
                                                setAlertDisplay(true);
                                                return;                                             
                                            }
                                            deletelocal("ShortDescriptions",chatSliceData.selectedChat)
                                            dispatch(chatSliceAction.closeContact({ chatId: chatSliceData.selectedChat }));
                                        }

                                    }} type="button" className="form-control btn btn-danger mt-3" style={{ height: "50%", width: "75%" }}>
                                        {" Close contact"}
                                    </button>
                                </div>
                            </li>
                        ) : (
                            <li style={{ width: "25%" }}>
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: "0.6rem" }}>
                                    <button onClick={() => {
                                        if (isAccountName("Schneider")) {
                                            if (isOtherSelected && (ShortDescription === "Other" || ShortDescription === "")) {
                                                setTicketErrorMessage(
                                                    <>
                                                    <span style={{ color: 'red' }}>
                                                        Please type a valid short description before closing this chat.                                             
                                                    </span>
                                                    </>
                                                );
                                                setAlertDisplay(true);
                                                timerRef.current = setTimeout(() => setAlertDisplay(false), 5000);
                                                return;
                                            }
                                            if (Resolution !== "" && Interaction !== "") {
                                                onSaveWrapupCode(true);
                                                dispatch(chatSliceAction.endChat({ chatId: chatSliceData.selectedChat }));
                                            } else {
                                                dispatch(agentSliceAction.setIsMissingWrapCode({ MissingWrapCode: true }));
                                                onSaveWrapupCode(true);
                                            }
                                        } else {
                                            onSaveWrapupCode(true)
                                            dispatch(chatSliceAction.endChat({ chatId: chatSliceData.selectedChat }));
                                        }
                                    }} type="button" className="form-control btn btn-danger mt-3" style={{ height: "50%", width: "75%" }}>
                                        <i className="fas fa-fw fas fa-comment-slash"></i>
                                        {(chatSliceData.selectedType === "monitoring") ? " End monitoring" : " End chat"}
                                    </button>
                                </div>
                            </li>
                        )}
                    </ul>
                ) : (
                    <></>
                )}
            </div>
        </div>

    )
}
export default ChatInfo;